import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

import {
    PaginatedResourcesState,
    ResourceBase,
    itemsPerPage,
    ResourcesState,
} from "@/domains/app/resource";
import { computed, ref } from "@vue/reactivity";
import { RelationConfigType, relations } from "../config";
import { ListItemConfig } from "../list";
import Search from "./Search.vue";
import { ComputedRef } from "vue";
import { QueryParams } from "../config";


export default /*#__PURE__*/_defineComponent({
  props: {
    relation: null,
    getSearchParams: null,
    headerText: null
  },
  emits: ["item:clicked"],
  setup(__props: any, { emit }: { emit: ({
    (e: "item:clicked", item: ListItemConfig): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    relation: keyof typeof relations;
    getSearchParams?: () => QueryParams;
    headerText?: string;
}





function isPaginatedResources<T extends ResourceBase>(
    resources: ResourcesState<T> | PaginatedResourcesState<T>
): resources is PaginatedResourcesState<T> {
    const keys = Object.keys(resources);
    return (
        keys.includes("nextPage") &&
        keys.includes("prevPage") &&
        keys.includes("toPage")
    );
}

if (!relations[props.relation])
    throw "Cannot create component: cannot find resources state";

const { getState, getLabel, loadingKey } = relations[
    props.relation
] as RelationConfigType;
const state = getState(
    props.getSearchParams ? props.getSearchParams() : undefined
);

const highlight = ref("");

let prevPage: () => Promise<void>,
    nextPage: typeof prevPage,
    toPage: (page: number) => Promise<void>,
    pagesCount: ComputedRef<number | null>;

if (isPaginatedResources(state)) {
    prevPage = state.prevPage;
    nextPage = state.nextPage;
    toPage = state.toPage;
    pagesCount = computed(() =>
        state.total.value !== null
            ? Math.ceil(state.total.value / itemsPerPage)
            : null
    );
}

const items = computed<ListItemConfig[]>(() =>
    state.data.value.map((v) => ({
        label: getLabel(v as any),
        uid: "" + v.id,
        value: v.id,
    }))
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.headerText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.headerText), 1))
      : _createCommentVNode("", true),
    _createVNode(Search, {
      items: _unref(items),
      "loading-key": _unref(loadingKey),
      search: _unref(state).search || null,
      navigation: { nextPage: _unref(nextPage), prevPage: _unref(prevPage), toPage: _unref(toPage), pages: _unref(pagesCount) },
      "onItem:clicked": _cache[0] || (_cache[0] = ($event: any) => ((highlight.value = $event.uid) && emit('item:clicked', $event)))
    }, {
      item: _withCtx((item) => [
        (item.uid === highlight.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(sélectionné)"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["items", "loading-key", "search", "navigation"])
  ], 64))
}
}

})